<template>
  <div class="fade-in">
    <div :class="['modal', { 'is-active': show }]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button class="delete" v-on:click="hide"></button>
        </header>
        <section class="modal-card-body">
          <slot></slot>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" v-on:click="confirm()">
            {{ confirmText() }}
          </button>
          <a class="button" v-on:click="hide">Cancel</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alert",

  props: ["title", "onConfirm", "confirmLabel"],

  data() {
    return {
      show: false
    };
  },

  methods: {
    open() {
      this.show = true;
    },
    hide() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      this.onConfirm();
    },
    confirmText() {
      return this.confirmLabel || "Confirm";
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
